import * as React from 'react';
import { useIntl } from 'react-intl';
import { useRecoilState } from 'recoil';
import { isTrafficLayerOpenAtom } from '../OnlineMapState';
import useAnalytics from '../../../hooks/useAnalytics';

interface ITrafficLayerControlProps {
  map: google.maps.Map;
}

export default function TrafficLayerControl(props: ITrafficLayerControlProps): JSX.Element {
  const { formatMessage: f } = useIntl();
  const [isTrafficLayerOpen, setIsTrafficLayerOpen] =
    useRecoilState<boolean>(isTrafficLayerOpenAtom);
  const [isTrafficMap, setIsTrafficMap] = React.useState<google.maps.TrafficLayer | false | null>(
    null
  );
  const { trackEvent } = useAnalytics();

  React.useEffect(() => {
    const trafficLayer = new google.maps.TrafficLayer();

    setIsTrafficMap(trafficLayer);
  }, []);

  const handleToggleTrafficLayer = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    event.preventDefault();
    if (isTrafficLayerOpen && isTrafficMap) {
      setIsTrafficLayerOpen(false);
      isTrafficMap.setMap(null);
      trackEvent(['map', 'click', 'Hide traffic layer']);
    } else if (isTrafficMap && props.map) {
      trackEvent(['map', 'click', 'Show traffic layer']);
      setIsTrafficLayerOpen(true);
      isTrafficMap.setMap(props.map);
    }
  };

  return (
    <a
      onClick={handleToggleTrafficLayer}
      data-cy="controls-on-map-trafficLayer"
      title={f({ id: 'map.trafficLayer' })}
      className={`${isTrafficLayerOpen ? `e-button-sq text-primary` : `e-button-sq`}`}
    >
      <i className="cmd-icons cmd-icon-traffic-light" />
    </a>
  );
}
